/**
 * providers.tsx — proveedores globales: router + sesión.
 */
import type { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider, ViewAsProvider } from "@/features/auth/index.js";
import { BrandThemeLoader } from "./BrandThemeLoader.js";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <BrowserRouter>
      <AuthProvider>
        {/* ViewAsProvider is nested inside AuthProvider so it can read isAuthenticated
            to clear the overlay on logout (TOG-01). */}
        <ViewAsProvider>
          {/* Re-skin global según la Marca; reacciona a la sesión. */}
          <BrandThemeLoader />
          {children}
        </ViewAsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
